import React, { useEffect, useState } from 'react'
import Loading from "../components/Loading"
import ProductCard from '../components/ProductCard'
import api from "../controller/api"
import { toast, Toaster } from "sonner"
import { useLocation, useParams } from 'react-router-dom'

export default function Product() {
    const [products, setProducts] = useState([])
    const [productByCateg, setProductByCateg] = useState([])
    const [pageLoading, setPageLoading] = useState(false)
    const [bookingList, setBookingList] = useState([])

    let { name } = useParams()
    if (name === "massage_and_spa") name = "Massage & Spa"
    if (name === "saree_draping") name = "Saree Draping"
    if (name === "nail_art") name = "Nail Art"
    const checkName = name?.toLowerCase()

    const location = useLocation()

    const fetchAllProducts = async () => {
        try {
            const { data: catres } = await api.get("/category/list")
            const catData = await catres?.data?.find((item) => item.categoryName.toLowerCase() === checkName)

            const { data: res } = await api.get("/product/list")
            const best = res?.data?.filter((item) => item.bestseller === true)
            setProducts(best)

            const result = res?.data?.filter((item) => item.categoryId === catData?._id)
            setProductByCateg(result)
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    const fetchBookings = async () => {
        try {
            const { data: res } = await api.get("/booking/list")
            setBookingList(res.data)
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    useEffect(() => {
        setPageLoading(true)
        fetchAllProducts()
        fetchBookings()
    }, [name])

    if (pageLoading) return <Loading />

    return (
        <div className='product-list'>
            <Toaster richColors position="top-center" />
            <h2>{location.pathname === "/overview" ? "Our Best Sellers" : "Dream come true"}</h2>
            <p>This is your sign to try these deals 👀</p>
            <div className='product-box'>
                {location.pathname === "/overview" ?
                    products.map((product) => product.bestseller && <ProductCard
                        key={product._id}
                        product={product}
                        bookingList={bookingList}
                    />)
                    : productByCateg.map((product) => <ProductCard
                        key={product._id}
                        product={product}
                        bookingList={bookingList}
                    />)}
            </div>
        </div>
    )
}
